let focusedSearchRequest = null;
let selectionStart = null;
let selectionEnd = null;
let requestedValue = null;

document.addEventListener("htmx:beforeRequest", (event) => {
  const form = event.detail?.elt;
  if (!form?.matches?.("[data-client-search-form]")) return;

  const input = form.querySelector("[data-client-search-input]");
  if (!input || document.activeElement !== input) return;

  focusedSearchRequest = event.detail.xhr;
  selectionStart = input.selectionStart;
  selectionEnd = input.selectionEnd;
  requestedValue = input.value;
});

document.addEventListener("htmx:afterSettle", (event) => {
  if (!focusedSearchRequest || event.detail?.xhr !== focusedSearchRequest) return;

  const input = document.querySelector("[data-client-search-input]");
  if (input) {
    const valueChangedDuringRequest = input.value !== requestedValue;
    const currentSelectionStart = input.selectionStart ?? input.value.length;
    const currentSelectionEnd = input.selectionEnd ?? currentSelectionStart;
    input.focus({preventScroll: true});

    if (valueChangedDuringRequest) {
      input.setSelectionRange(currentSelectionStart, currentSelectionEnd);
    } else {
      input.setSelectionRange(selectionStart, selectionEnd);
    }
  }

  focusedSearchRequest = null;
  requestedValue = null;
});
